const install = () => {
  if (window && !window.matchMedia) {
    window.matchMedia = function () {
      return {
        matches: false,
        addListener() {},
        removeListener() {},
      };
    };
  }

  global.matchMedia = global.matchMedia || window.matchMedia;
};

const uninstall = () => {
  delete global.matchMedia;
};

export default { install, uninstall };
